/*
 * Citera — product.js
 * Product-page-only behavior: variant selection + media gallery, gift-card
 * recipient, sticky add-to-cart, buy now, recommendations, recently-viewed
 * recording. Loaded (deferred) by sections/product.liquid ONLY, so other
 * templates never pay for it. Shared cart/dialog plumbing comes from global.js
 * via window.Citera.
 */
(function () {
  "use strict";
  if (!document.querySelector("[data-product]")) return;
  var C = window.Citera || {};
  var strings = C.strings || {};
  var announce = C.announce || function () {};
  var openDialog = C.openDialog || function () {};
  var postCart = C.postCart;
  var formToItem = C.formToItem;
  var showCartError = C.showCartError || function () {};
  var clearCartError = C.clearCartError || function () {};
  var refreshCartDrawer = C.refreshCartDrawer || function () {};
  var CART_DRAWER_ID = C.cartDrawerId || "cart-drawer";

  /* ---------- Product: variant selection + media gallery ---------- */
  function variantData(product) {
    var script = product.querySelector("[data-variant-data]");
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function updateVariant(product) {
    var controls = product.querySelectorAll("[data-option-index]");
    if (!controls.length) return;
    var chosen = Array.prototype.map.call(controls, function (el) {
      if (el.tagName === "SELECT") return el.value;
      var checked = el.querySelector("input:checked");
      return checked ? checked.value : "";
    });
    var match = variantData(product).find(function (variant) {
      return variant.options.every(function (value, i) {
        return value === chosen[i];
      });
    });

    var idInput = product.querySelector("[data-variant-id]");
    var priceEls = product.querySelectorAll("[data-price]");
    var button = product.querySelector("[data-add-button]");
    var label = product.querySelector("[data-add-label]");

    if (match && idInput) idInput.value = match.id;

    // Swap the gallery to the selected variant's image (variant/swatch gallery).
    if (match && match.featured_media_id) {
      var mediaThumb = product.querySelector('[data-media-id="' + match.featured_media_id + '"]');
      if (mediaThumb) activateThumb(product, mediaThumb);
    }

    priceEls.forEach(function (priceEl) {
      if (match && match.on_sale) {
        priceEl.innerHTML =
          '<span class="product__price-sale">' +
          match.price +
          '</span> <s class="product__price-compare">' +
          match.compare_at_price +
          "</s>";
      } else if (match) {
        priceEl.textContent = match.price;
      }
    });

    // Unit price (e.g. "$0.50/100ml") follows the selected variant.
    var unitPriceEl = product.querySelector("[data-unit-price]");
    if (unitPriceEl && match) {
      if (match.unit_price) {
        var valueEl = unitPriceEl.querySelector("[data-unit-price-value]");
        var baseEl = unitPriceEl.querySelector("[data-unit-price-base]");
        if (valueEl) valueEl.textContent = match.unit_price;
        if (baseEl) baseEl.textContent = (match.unit_price_base || "").replace(/^1\s+/, "");
        unitPriceEl.hidden = false;
      } else {
        unitPriceEl.hidden = true;
      }
    }

    if (button && label) {
      var available = match && match.available;
      button.disabled = !available;
      label.textContent = available ? label.dataset.add : label.dataset.soldout;
    }

    // Rebuild the subscription plan list for the selected variant (plans + prices
    // are per-variant). Preserves the current one-time/subscribe choice.
    var planSelect = product.querySelector("[data-selling-plan]");
    if (planSelect && match) {
      var plans = match.selling_plans || [];
      var previous = planSelect.value;
      planSelect.innerHTML = plans
        .map(function (p) {
          return (
            '<option value="' + p.id + '">' + p.name + " — " + p.price + "</option>"
          );
        })
        .join("");
      if (previous) planSelect.value = previous;
      var subActive = product.querySelector("[data-purchase-subscription]");
      var isSub = subActive && subActive.checked;
      planSelect.hidden = !isSub || !plans.length;
      planSelect.disabled = !isSub || !plans.length;
    }

    if (!match) return;

    // Keep the URL shareable: reflect the chosen variant in ?variant= so reload,
    // back/forward, and copied links restore this selection.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", match.id);
      window.history.replaceState({}, "", url);
    } catch (e) {
      /* very old browsers: skip URL sync */
    }

    // Sticky buy bar thumbnail follows the variant image.
    var stickyImg = product.querySelector(".product__sticky-img");
    if (stickyImg && match.featured_image) {
      stickyImg.src = match.featured_image;
      stickyImg.removeAttribute("srcset");
    }

    // Pickup availability is rendered server-side per variant — refetch it via
    // the Section Rendering API so locations/stock match the new selection.
    var pickupWrap = product.querySelector("[data-pickup-availability]");
    if (pickupWrap) {
      if (pickupController) pickupController.abort();
      pickupController = new AbortController();
      fetch(
        window.location.pathname +
          "?variant=" +
          match.id +
          "&section_id=pickup-availability",
        { signal: pickupController.signal }
      )
        .then(function (r) {
          return r.ok ? r.text() : "";
        })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("[data-pickup-root]");
          if (fresh) pickupWrap.innerHTML = fresh.innerHTML;
        })
        .catch(function () {
          /* aborted or offline: keep the current pickup info */
        });
    }
  }
  var pickupController = null;

  // Purchase options: toggle the subscription plan select on/off. When one-time is
  // chosen the select is disabled so `selling_plan` is not submitted at all.
  document.addEventListener("change", function (event) {
    if (!event.target.closest("[data-purchase-options]")) return;
    if (event.target.name !== "purchase_option") return;
    var fieldset = event.target.closest("[data-purchase-options]");
    var planSelect = fieldset.querySelector("[data-selling-plan]");
    if (!planSelect) return;
    var isSub = event.target.value === "subscription";
    var hasPlans = planSelect.options.length > 0;
    planSelect.hidden = !isSub || !hasPlans;
    planSelect.disabled = !isSub || !hasPlans;
  });

  // Country / language selectors submit their localization form on change.
  document.addEventListener("change", function (event) {
    var loc = event.target.closest("[data-localization-select]");
    if (loc && loc.form) {
      loc.form.submit();
      return;
    }
  });

  // Gift-card recipient: reveal the fields + set the "send to recipient" flag.
  document.addEventListener("change", function (event) {
    var toggle = event.target.closest("[data-gift-toggle]");
    if (!toggle) return;
    var wrap = toggle.closest("[data-gift-recipient]");
    if (!wrap) return;
    var fields = wrap.querySelector("[data-gift-fields]");
    var flag = wrap.querySelector("[data-gift-enabled]");
    if (fields) {
      fields.hidden = !toggle.checked;
      // Disabled inputs don't submit — so unchecking clears any typed recipient
      // properties from the add-to-cart payload.
      fields.querySelectorAll("input:not([data-gift-enabled]), textarea").forEach(function (el) {
        el.disabled = !toggle.checked;
      });
    }
    if (flag) flag.value = toggle.checked ? "on" : "";
  });

  // Gift-card recipient: fill the timezone offset Shopify needs for scheduled
  // ("Send on") delivery. Minutes, as Date#getTimezoneOffset reports.
  document.querySelectorAll("[data-gift-offset]").forEach(function (el) {
    el.value = new Date().getTimezoneOffset().toString();
  });

  document.addEventListener("change", function (event) {
    var control = event.target.closest("[data-option-index]");
    if (!control) return;
    var product = control.closest("[data-product]");
    if (!product) return;
    if (control.classList.contains("product__swatches")) {
      control.querySelectorAll(".product__swatch").forEach(function (labelEl) {
        var input = labelEl.querySelector("input");
        labelEl.classList.toggle("is-selected", !!(input && input.checked));
      });
      var checked = control.querySelector("input:checked");
      var out = control.parentElement.querySelector("[data-swatch-selected]");
      if (out && checked) out.textContent = checked.value;
    }
    updateVariant(product);
  });

  function activateThumb(product, thumb) {
    var main = product && product.querySelector("[data-media-main]");
    if (!main || !thumb) return;
    main.src = thumb.getAttribute("data-full");
    main.srcset = thumb.getAttribute("data-srcset");
    var alt = thumb.getAttribute("data-alt");
    if (alt !== null) main.alt = alt;
    var focal = thumb.getAttribute("data-focal");
    main.style.objectPosition = focal ? focal : "";
    product.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.setAttribute("aria-pressed", t === thumb ? "true" : "false");
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-thumb]");
    if (!thumb) return;
    activateThumb(thumb.closest("[data-product]"), thumb);
  });

  /* ---------- Sticky add-to-cart: show when the main buy button scrolls away, hide over the footer ---------- */
  document.querySelectorAll("[data-product]").forEach(function (product) {
    var sticky = product.querySelector("[data-sticky-atc]");
    var anchor = product.querySelector("[data-add-button]");
    if (!sticky || !anchor || !("IntersectionObserver" in window)) return;
    var footer = document.querySelector(".footer");
    var pastAnchor = false;
    var footerVisible = false;
    function update() {
      sticky.classList.toggle("is-visible", pastAnchor && !footerVisible);
    }
    new IntersectionObserver(
      function (entries) {
        // Show only once the buy button has been scrolled PAST (above the
        // viewport) — not while it still sits below, unseen, on page load.
        var entry = entries[0];
        pastAnchor = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      },
      { rootMargin: "0px 0px -80px 0px" },
    ).observe(anchor);
    if (footer) {
      new IntersectionObserver(
        function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        },
        { rootMargin: "0px 0px 0px 0px" },
      ).observe(footer);
    }
  });

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-sticky-add]");
    if (!btn) return;
    var product = btn.closest("[data-product]");
    var form = product && product.querySelector("form[data-cart-form]");
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
  });

  // Buy now: add the item, then go straight to checkout.
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-buy-now]");
    if (!btn) return;
    if (btn.disabled) return;
    var product = btn.closest("[data-product]");
    var form = product && product.querySelector("form[data-cart-form]");
    if (!form) return;
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    clearCartError(form);
    var fd = new FormData(form);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [formToItem(fd)] }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && (data.status || data.description)) {
          btn.removeAttribute("aria-busy");
          btn.disabled = false;
          showCartError(form, data.description || data.message);
          return;
        }
        window.location.href = window.Shopify.routes.root + "checkout";
      })
      .catch(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
        showCartError(form);
      });
  });

  /* ---------- Product recommendations (native Shopify API) ---------- */
  document.querySelectorAll("[data-product-recs]").forEach(function (el) {
    var url = el.getAttribute("data-url");
    if (!url) return;
    var load = function () {
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, "text/html");
          var next = parsed.querySelector("[data-product-recs]");
          if (next) el.replaceWith(next);
        })
        .catch(function () {});
    };
    // Usually below the fold: fetch near the viewport, not at page load, so the
    // request doesn't compete with the page's critical resources.
    if ("IntersectionObserver" in window) {
      var recsIO = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          recsIO.disconnect();
          load();
        },
        { rootMargin: "600px 0px" }
      );
      recsIO.observe(el);
    } else {
      load();
    }
  });

  // Add all (frequently bought together): current product + all recommended single-variant items.
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-add-all]");
    if (!btn) return;
    var scope = btn.closest("[data-product-recs]") || document;
    var ids = [];
    scope.querySelectorAll("form[data-cart-form] [name='id']").forEach(function (input) {
      if (input.value) ids.push(input.value);
    });
    var main = document.querySelector("[data-product] [data-variant-id]");
    if (main && main.value) ids.unshift(main.value);
    if (!ids.length) return;
    if (btn.disabled) return;
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    postCart("cart/add.js", {
      items: ids.map(function (id) {
        return { id: id, quantity: 1 };
      }),
    })
      .then(function (data) {
        if (data && (data.status || data.description)) {
          announce(data.description || data.message || strings.cartError);
          return;
        }
        refreshCartDrawer(data.sections);
        openDialog(document.getElementById(CART_DRAWER_ID));
        announce(strings.cartAdded || "Added to cart");
      })
      .catch(function () {
        announce(strings.cartError || "Couldn't update the cart");
      })
      .finally(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
      });
  });


  /* ---------- Recently viewed: record the current product ---------- */
  var KEY = "citera:recent";
  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
    // Record the current product.
    var itemEl = document.querySelector("[data-recent-item]");
    if (itemEl) {
      try {
        var item = JSON.parse(itemEl.textContent);
        if (item && item.handle) {
          var list = readRecent().filter(function (p) {
            return p.handle !== item.handle;
          });
          list.unshift(item);
          localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
        }
      } catch (e) {}
    }
})();
